import React, { useState, useEffect } from 'react';
import { BaseButton } from '@repo/common';
import { ReactComponent as CheckIcon } from '@repo/common/assets/icons/16px/icon_16px_check.svg';

function SortByList({ onSelect, selected }) {
  const options = ['By Date', 'By Completion'];
  const [tempSelected, setTempSelected] = useState(selected);

  useEffect(() => {
    setTempSelected(selected);
  }, [selected]);

  return (
    <div
      className='w-full min-w-[136px] bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-lg p-2 shadow-popup-02 md:min-w-[136px]'
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => {
          const isSelected = option === tempSelected;

          return (
            <li
              key={option}
              className='flex items-center rounded-lg transition-colors duration-150'
            >
              <BaseButton
                type='text'
                size='m'
                icon={
                  isSelected ? (
                    <CheckIcon className='text-icon-primary' />
                  ) : (
                    <span className='w-4 h-4 inline-block' />
                  )
                }
                bgclass='bg-grayscale-gray00'
                borderclass='border-none'
                textclass='justify-start'
                hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                width='100%'
                onMouseDown={() => {
                  setTempSelected(option);
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTempSelected(option);
                  onSelect(option);
                }}
                leftalign='true'
              >
                {option}
              </BaseButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default SortByList;
